import { supabase } from './supabase';

interface MagicLinkResult {
  success: boolean;
  magicLink?: string;
  token?: string;
  expiresAt?: string;
  error?: string;
}

export async function generateMagicLinkForUser(userId: string): Promise<MagicLinkResult> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      return {
        success: false,
        error: 'Niet ingelogd als admin',
      };
    }

    const apiUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/admin-generate-magic-link`;
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${session.access_token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: userId,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.error || 'Kon geen magic link aanmaken',
      };
    }

    const data = await response.json();

    return {
      success: true,
      magicLink: data.magic_link,
      token: data.token,
      expiresAt: data.expires_at,
    };
  } catch (error: any) {
    console.error('Error generating magic link:', error);
    return {
      success: false,
      error: error.message || 'Er ging iets mis',
    };
  }
}

export async function getActiveMagicLink(userId: string): Promise<MagicLinkResult> {
  return await generateMagicLinkForUser(userId);
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);

    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.select();

    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    } catch (err) {
      document.body.removeChild(textArea);
      return false;
    }
  }
}
